import { render, staticRenderFns } from "./CommoditiesReport.vue?vue&type=template&id=85e9a50c&scoped=true"
import script from "./CommoditiesReport.vue?vue&type=script&lang=ts"
export * from "./CommoditiesReport.vue?vue&type=script&lang=ts"
import style0 from "./CommoditiesReport.vue?vue&type=style&index=0&id=85e9a50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e9a50c",
  null
  
)

export default component.exports